import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "52",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path stroke=\"#fff\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12.693 45.406h19.293V1.162H1.016v44.244h5.33\"></path><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8.109 9.824h16.784M8.109 15.927h16.784M8.109 22.538h16.784M8.109 29.149h16.784\"></path><path fill=\"#36A5A2\" stroke=\"#fff\" stroke-width=\"2\" d=\"M14.232 37.778a4.59 4.59 0 0 1-4.585 4.594 4.59 4.59 0 0 1-4.585-4.594 4.59 4.59 0 0 1 4.585-4.595 4.59 4.59 0 0 1 4.585 4.595Z\"></path><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17.754 35.252h7.139\"></path><path stroke=\"#fff\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M6.6 41.338V51l3.047-3.092L12.693 51v-9.663\"></path>", 5)
  ]))]))
}
export default { render: render }